import isEmpty from 'lodash/isEmpty';
import { useCallback } from 'react';
import { useRouter } from '../../../no-code/hooks/useRouter';
import { useDrawer } from '../../Drawer/useDrawer';
import type { UrlCta } from '../types';

export const useUrlCtaAction = () => {
  const drawerContext = useDrawer();
  const hideDrawer = 'hide' in drawerContext ? drawerContext.hide : undefined;

  const router = useRouter();

  const onClick = useCallback(
    ({ cta }: { cta: UrlCta }) => {
      hideDrawer?.();
      if (cta.openInNewPage) {
        if (isEmpty(cta.url)) {
          console.error('Invalid URL for notification CTA:', cta.url);
          return;
        }
        window.open(cta.url);
      } else {
        router.push(cta.url);
      }
    },
    [hideDrawer, router],
  );

  return onClick;
};
